{
  "signUp": "S'inscrire",
  "haveAccount": "Vous avez déja un compte?",
  "signIn": "Se connecter",
  "firstName": "Prénom",
  "lastName": "Nom",
  "password": "Mot de passe",
  "passwordConfirm": "Confirmer le mot de passe",
  "8char": "8 caracters minimum",
  "oneNumber": "Un nombre",
  "oneLower": "Un caractère minisculee",
  "oneUpper": "Un caractère majuscule",
  "toggle_1": "Otakus may use my contact data to keep me informed of products, services and offerings.",
  "toggle_2": "I accept the product Terms and conditions of this registration form.",
  "passwordNotTheSame": "Les mots de passe sont différents",
  "fieldRequired": "Ce champs est obligatoire",
  "sign_up_done": "Compte crée",
  "check_email": "Nous nous avons envoyé un E-mail, pour confrimer votre addresse"
}
